/* eslint-disable no-unused-vars */
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import PageTitle from './layout/PageTitle';

export default function ListProjects() {
  const navigate = useNavigate();
  const { user_id } = useParams();
  const [userName, setUserName] = useState({});
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    getProjects();
    getUser();
  }, []);

  function getUser() {
    axios.get(`https://filenamebuilder.com/api/users.php/${user_id}`).then(function (response) {
      setUserName(response.data.name);
    });
  }

  function getProjects() {
    axios.get(`https://filenamebuilder.com/api/projects.php/${user_id}`).then(function (response) {
      setProjects(response.data);
    });
  }

  const deleteProject = (id) => {
    axios.delete(`https://filenamebuilder.com/api/projects.php/${id}`).then(function (response) {
      getProjects();
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const inputs = {
      user_id: user_id,
      name: event.target.name.value,
      description: event.target.description.value,
      event_date: event.target.event_date.value,
      tags: event.target.tags.value,
    };
    axios
      .post(`https://filenamebuilder.com/api/projects.php/create`, inputs)
      .then(function (response) {
        // To do: Clear form, show success message by highlighting the new project in the projects list
        getProjects();
      });
  };

  return (
    <>
      <PageTitle title={`${userName} Projects`} />
      <Container>
        <Row>
          <Col>
            <h4>Create Project</h4>
            <form onSubmit={handleSubmit} className="row g-3 mb-6">
              <div className="col-sm-12 col-md-12">
                <div className="form-floating">
                  <input
                    className="form-control"
                    name="name"
                    id="name"
                    type="text"
                    placeholder="Project title"
                  />
                  <label htmlFor="name">Project title</label>
                </div>
              </div>
              <div className="col-12 gy-6">
                <div className="form-floating">
                  <textarea
                    className="form-control"
                    name="description"
                    id="description"
                    placeholder="Leave a comment here"
                    style={{ height: '100px' }}
                  ></textarea>
                  <label htmlFor="description">Description</label>
                </div>
              </div>
              <div className="col-sm-12 col-md-12">
                <div className="form-floating form-floating-advance-select">
                  <input
                    type="text"
                    className="form-control"
                    name="event_date"
                    id="event_date"
                    placeholder="MM/DD/YYYY"
                  />
                  <label htmlFor="event_date">Date</label>
                </div>
              </div>
              <div className="col-sm-12 col-md-12">
                <div className="form-floating form-floating-advance-select">
                  <input
                    type="text"
                    className="form-control"
                    name="tags"
                    id="tags"
                    placeholder="Add tags"
                  />
                  <label htmlFor="tags">Tags</label>
                </div>
              </div>
              <div className="col-12 gy-6">
                <div className="row g-3 justify-content-end">
                  <div className="col-auto">
                    <button className="btn btn-phoenix-primary px-5">Cancel</button>
                  </div>
                  <div className="col-auto">
                    <button className="btn btn-primary px-5 px-sm-15">Create Project</button>
                  </div>
                </div>
              </div>
            </form>
          </Col>
          <Col>
            <h4>Projects</h4>
            <Table hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>name</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {projects.map((project, key) => (
                  <tr key={key}>
                    <td>{project.id}</td>
                    <td>{project.name}</td>
                    <td>
                      <Button onClick={() => navigate(`../project/${project.id}`)}>View</Button>
                      &nbsp;<Button onClick={() => deleteProject(project.id)}>Delete</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </>
  );
}
